module.exports = __webpack_public_path__ + "img/real-sociedad-logo-icon.d22ea1b8.png";